/** Sizes for the weight indicator: Md at rest, Lg while the score-weights panel is open. */
enum WeightIndicatorSize {
  Md = 'md',
  Lg = 'lg',
}

interface WeightIndicatorProps {
  /** Weight of this metric as an integer percentage of the total score (e.g. 33 renders "33%"). */
  pct: number;
  /**
   * Text color class (e.g. 'text-pink-600') tinting the bolt while the score-weights
   * panel is open; the percentage then reads in tertiary. Gray when omitted.
   */
  accentClassName?: string;
  /**
   * Renders in a faded color, overriding any accent (used while another cell is isolated).
   * @default false
   */
  isDisabled?: boolean;
  /**
   * Visual size: Md (14px bolt, 10px label) at rest, Lg (18px bolt, 14px label) while
   * the score-weights panel is open — stepped-up emphasis for the active state.
   * @default WeightIndicatorSize.Md
   */
  size?: WeightIndicatorSize;
  /** Additional class name for styling */
  className?: string;
}

export { WeightIndicatorSize };
export type { WeightIndicatorProps };
